(ns renolit-roofing-service.websocket.message-handler
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.entity-list :as entity-list]
            [renolit-roofing-service.service.notification :as srv.ntf]))

(rf/reg-event-fx
 ::push-notification
 (fn [{:keys [db]} _]
   {:fx (cond-> [[:dispatch [::srv.ntf/get-notifications-unread-count]]]
          (seq (get-in db [:notifications :list]))
          (into [[:dispatch [::entity-list/update-pagination
                             :notifications
                             {:page 0}]]
                 [:dispatch [::entity-list/load-list
                             {:entity-key :notifications
                              :uri "/api/notifications"}]]]))}))

(defmulti handle-message :id)

(defmethod handle-message :chsk/handshake
  [_]
  (.info js/console "[Renolit RaaS] Connection established!"))

(defmethod handle-message :chsk/state
  [{:keys [event]}]
  (rf/console :debug "[Renolit RaaS] Channel socket state changed: " (pr-str event)))

(defmethod handle-message :chsk/ws-ping
  [_]
  (rf/console :debug "[Renolit RaaS] Keep alive"))

(defmethod handle-message :tools-backend/notification
  [_]
  (rf/dispatch [::push-notification]))

(defmethod handle-message :default
  [{:keys [id]}]
  (rf/console :debug "[Renolit RaaS] Unknown WebSockets event message: " (pr-str id)))
